import { render, staticRenderFns } from "./onUploadError-editor.vue?vue&type=template&id=2c0c749a&scoped=true&"
import script from "./onUploadError-editor.vue?vue&type=script&lang=js&"
export * from "./onUploadError-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c749a",
  null
  
)

export default component.exports